import { getDefaultStore } from "../../../pages/LandingPage/helpers";
import { IAMUserState, IOption, LaunchMode, StoreState } from "../../../types";

import { getLaunchContext } from "../../iframe/getLaunchContext";
import { resolvePaymentsContext } from "./resolvePaymentsContext";

export interface EffectiveUserContext {
  launchMode: LaunchMode;
  effectiveEnterpriseId: string;
  effectiveStoreOption: IOption;
  effectiveIamUserState: IAMUserState;
  effectiveIamUserStoresCommaSeparated: string;
}

interface ResolveLaunchContextParams {
  enterpriseId: string;
  stores: StoreState[];
  iamUserState: IAMUserState;
}

export const resolveLaunchContext = async ({
  enterpriseId,
  stores,
  iamUserState,
}: ResolveLaunchContextParams): Promise<EffectiveUserContext> => {
  const defaultStore = getDefaultStore(stores);

  const launchContext = getLaunchContext();

  const fallbackIamUserStoresCommaSeparated = iamUserState.extendedAccountInfo
    .map((item) => item.storeId)
    .join(",");

  if (!launchContext) {
    return {
      launchMode: "default",
      effectiveEnterpriseId: enterpriseId,
      effectiveStoreOption: defaultStore,
      effectiveIamUserState: iamUserState,
      effectiveIamUserStoresCommaSeparated: fallbackIamUserStoresCommaSeparated,
    };
  }

  switch (launchContext.launchMode) {
    case "payments":
      return resolvePaymentsContext({
        context: launchContext.payments,
        fallbackEnterpriseId: enterpriseId,
        fallbackStore: defaultStore,
        fallbackIamUserState: iamUserState,
        fallbackIamUserStoresCommaSeparated,
      });

    default:
      return {
        launchMode: "default",
        effectiveEnterpriseId: enterpriseId,
        effectiveStoreOption: defaultStore,
        effectiveIamUserState: iamUserState,
        effectiveIamUserStoresCommaSeparated:
          fallbackIamUserStoresCommaSeparated,
      };
  }
};
